import { useEffect, useState, useMemo }	from 'react'
import { useJustificationPage }	from '../../contexts/JustificationPageContext'
import { useUser }				from '../../contexts/UserContext'
import ComparisionTable			from './ComparisionTable';
import ComparisionTableCIC	from './ComparisionTableCIC';
import api                      from '../../services/api.js'
import LoadingTable 			from './LoadingTable';
import EmptyResultSection		from '../../components/Sections/emptyResultSection.js';

function ComparisionTableContainer() {

	const { 

		selectedComparisionTypeId,
		selectedComparisionDate, 
		updateComparisionTable,

		handerOpenJustificationListModal,
		setSelectedComparisionId,

		handleUpadeComparisionTable,
		comparisionTypes

	} = useJustificationPage()


	const { userData } = useUser()

	const [ tableData, 	   setTableData		] = useState(null)
	const [ tableColumns,  setTableColumns 	] = useState(null)
	const [ isLoading,     setLoading		] = useState(true)
	const [ hasPermission, setHasPermission ] = useState(false)

	const [ externalData,  setExternalData  ] = useState(null)

	const [ textFilter, 	   setTextFilter	] = useState('')
	const [ deltaFilter,	   setDeltaFilter	] = useState('todos') // 'todos' | 'positivo' | 'negativo'
	const [ statusFilter,	   setStatusFilter	] = useState('todos') // 'todos' | 'ok' | 'naoOk'

	const handlerOpenJustificationsFromComparision = (comparisionId) => {
	
		handerOpenJustificationListModal()
		setSelectedComparisionId(comparisionId)

	}

	const fetchTableData = async () => {

		try{
			
			const response = await api.get('/getComparisions',   {
				params: {
					comparisionTypeId: 	selectedComparisionTypeId,
					comparisionDate: 	selectedComparisionDate
			}})

			const { comparisionsList, comparisionColumns, externalData } = response.data

			setExternalData(externalData ?? null)
			setTableData(comparisionsList ?? null)
			setTableColumns(comparisionColumns ?? null)

		}catch(error){
			
			console.log('❌ ComparisionTable - fetchTableData', error)

		} finally {

			setLoading(false)
		
		}
	}
    
	const handerDeleteComparision = async (comparisionId) => {

		try{

			await api.delete(`/deleteComparision/${comparisionId}`, { data: { userData } })

			handleUpadeComparisionTable()

		}catch(error){

			console.log('❌ ComparisionTable - deleteComparision', error)

		}

	}

	const filteredTableData = useMemo(() => {

		if (!Array.isArray(tableData)) return tableData

		let result = tableData

		// filtro de texto, múltiplos termos separados por ';'
		const terms = textFilter
			.split(';')
			.map((term) => term.trim().toLowerCase())
			.filter(Boolean)

		if (terms.length > 0) {

			result = result.filter((data) => {

				const searchableText = [
					data.ownerOperation?.name,
					data.ownerTerminal?.name,
					data.ownerRailway?.name,
					data.ownerProduct?.name,
				].filter(Boolean).join(' ').toLowerCase()

				return terms.every((term) => searchableText.includes(term))

			})

		}

		// filtro de delta (executado - planejado)
		if (deltaFilter !== 'todos') {

			result = result.filter((data) => {

				const delta = Number(data.executed) - Number(data.planned)

				if (deltaFilter === 'positivo') return delta > 0
				if (deltaFilter === 'negativo') return delta < 0

				return true

			})

		}

		// filtro de status (justificado ou não)
		if (statusFilter !== 'todos') {

			result = result.filter((data) => {

				if (statusFilter === 'ok')    return data.isJustified
				if (statusFilter === 'naoOk') return !data.isJustified

				return true

			})

		}

		return result

	}, [ tableData, textFilter, deltaFilter, statusFilter ])

    useEffect(() => { 
		

		if (!selectedComparisionTypeId || !selectedComparisionDate) { 
			setLoading(false) 
			return
		} 

		fetchTableData() 	

		const canEditJustificativas = userData.permissions.some((permission) =>
			permission.module    === 'Editar Justificativas' &&
			permission.isAllowed === true
		);

		setHasPermission(canEditJustificativas);

	}, [ selectedComparisionTypeId, selectedComparisionDate, updateComparisionTable, userData ]);


    return(
		
		<>
			{
				isLoading ? (
					
					<LoadingTable/>

				) : externalData ? (
					<>
					<ComparisionTableCIC tableData={externalData} />
					</>
				) : (

					tableData?.length > 0 ? (				
				
						<ComparisionTable 
							
							tableColumns={tableColumns} 													
							tableData={filteredTableData} 															
							onOpenJustificationFromComparision={handlerOpenJustificationsFromComparision}
							handerDeleteComparision={handerDeleteComparision}	
							hasPermission={hasPermission} 

							textFilter={textFilter}
							setTextFilter={setTextFilter}
							deltaFilter={deltaFilter}
							setDeltaFilter={setDeltaFilter}
							statusFilter={statusFilter}
							setStatusFilter={setStatusFilter}
							
						/>

					) : (
						<EmptyResultSection />
					)
				)
			}

		</>

	)

}

export default ComparisionTableContainer